import script from "./InventoryMonthlyColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryMonthlyColumn.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryMonthlyColumn.vue?vue&type=style&index=0&id=e426ad70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e426ad70"]])

export default __exports__